// Constant for repository id URL parameter
export const REPOSITORY_ID_PARAM = 'repositoryId';
